<template>
  <div class="rc-l-split h-100">
    <div class="container">
      <div class="row flex-column-reverse flex-md-row h-100">
        <div class="rc-l-split--extra col-md-5">
          <slot name="content-left"></slot>
        </div>
        <div class="rc-l-split--main col-md-7 h-100">
          <div class="row align-items-start justify-content-center g-0 h-100">
            <div class="rc-l-split--form col">
              <slot name="content-right"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RcContentSplit"
};
</script>
